"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byEnvironment = exports.environmentMapper = exports.ENVIRONMENTS = void 0;
exports.ENVIRONMENTS = {
    local: 'local',
    stage: 'stage',
    prestage: 'prestage',
    preprod: 'preprod',
    prod: 'prod',
};
function environmentMapper(map) {
    return (url = window.origin) => { var _a; return (_a = map[url]) !== null && _a !== void 0 ? _a : exports.ENVIRONMENTS.prod; };
}
exports.environmentMapper = environmentMapper;
const isEnvironment = (getEnvironment) => (env) => {
    return getEnvironment() === env;
};
function byEnvironment(getEnvironment) {
    return function byEnvironment(envToFnMap) {
        const env = getEnvironment();
        return envToFnMap[env]();
    };
}
exports.byEnvironment = byEnvironment;
function default_1(getEnvironment) {
    return {
        isEnvironment: isEnvironment(getEnvironment),
        byEnvironment: byEnvironment(getEnvironment),
    };
}
exports.default = default_1;
//# sourceMappingURL=environments.js.map